import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

export async function endPartyClient(partyId: string) {
  if (!partyId) {
    throw new Error('Party ID required');
  }

  await updateDoc(doc(db, 'parties', partyId), {
    isActive: false,
    hostPresent: false,
    currentSong: null,
    endedAt: serverTimestamp(),
  });
}